(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pura-selection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pura-slider')) {
    class PuraSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.pura-sel__track');
        if (!this.track) return;
        this.items = [...this.track.children];
        this.prev = this.querySelector('[data-dir="-1"]');
        this.next = this.querySelector('[data-dir="1"]');
        this.current = this.querySelector('[data-current]');
        this.total = this.querySelector('[data-total]');
        if (this.total) this.total.textContent = String(this.items.length).padStart(3, '0');

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        [this.prev, this.next].forEach((b) => b && b.addEventListener('click', () => this.go(Number(b.dataset.dir))));
        this.bindDrag();
        this.update();
      }

      step() {
        const first = this.items[0];
        if (!first) return 0;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      go(dir) {
        this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        const x = this.track.scrollLeft;
        if (this.prev) this.prev.disabled = x <= 2;
        if (this.next) this.next.disabled = x >= max;
        const i = Math.min(this.items.length, Math.round(x / (this.step() || 1)) + 1);
        if (this.current) this.current.textContent = String(i).padStart(3, '0');
      }

      bindDrag() {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        let startX = 0, startLeft = 0, moved = false, down = false;
        this.track.addEventListener('pointerdown', (e) => {
          if (e.button !== 0) return;
          down = true; moved = false;
          startX = e.clientX; startLeft = this.track.scrollLeft;
        });
        window.addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 6) { moved = true; this.track.classList.add('is-dragging'); }
          if (moved) this.track.scrollLeft = startLeft - dx;
        });
        window.addEventListener('pointerup', () => {
          if (!down) return;
          down = false;
          if (moved) {
            this.track.classList.remove('is-dragging');
            const step = this.step();
            if (step) this.track.scrollTo({ left: Math.round(this.track.scrollLeft / step) * step, behavior: 'smooth' });
          }
        });
        this.track.addEventListener('dragstart', (e) => e.preventDefault());
      }
    }
    customElements.define('pura-slider', PuraSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pura-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pura-video-hero')) {
    class PuraVideoHero extends HTMLElement {
      connectedCallback() {
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.userPaused = this.reduce.matches || this.dataset.autoplay === 'false';
        this.toggle = this.parentElement.querySelector('.pura-vh__toggle');
        this.onToggle = this.onToggle.bind(this);
        this.onMediaChange = () => this.sync();
        if (this.toggle) this.toggle.addEventListener('click', this.onToggle);
        this.mobile.addEventListener('change', this.onMediaChange);

        this.querySelectorAll('video').forEach((v) => {
          v.muted = true;
          v.setAttribute('muted', '');
          v.playsInline = true;
          v.setAttribute('aria-hidden', 'true');
          v.setAttribute('tabindex', '-1');
          v.addEventListener('playing', () => v.parentElement.classList.add('is-playing'));
        });

        this.io = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.15 });
        this.io.observe(this);
        this.updateToggle();
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
        this.mobile.removeEventListener('change', this.onMediaChange);
      }

      activeVideo() {
        const wrappers = [...this.querySelectorAll('.pura-vh__video')];
        return wrappers
          .filter((w) => getComputedStyle(w).display !== 'none')
          .map((w) => w.querySelector('video'))
          .find(Boolean);
      }

      sync() {
        const active = this.activeVideo();
        this.querySelectorAll('video').forEach((v) => {
          if (v !== active || !this.visible || this.userPaused) {
            if (!v.paused) v.pause();
          } else {
            if (v.preload === 'none') v.preload = 'auto';
            const p = v.play();
            if (p && p.catch) p.catch(() => {});
          }
        });
      }

      onToggle() {
        this.userPaused = !this.userPaused;
        this.sync();
        this.updateToggle();
      }

      updateToggle() {
        if (!this.toggle) return;
        this.toggle.classList.toggle('is-paused', this.userPaused);
        this.toggle.setAttribute('aria-label', this.userPaused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
      }
    }
    customElements.define('pura-video-hero', PuraVideoHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pura-whatsapp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      document.querySelectorAll('.pura-wa--reveal').forEach((el) => {
        if (el.dataset.bound) return;
        el.dataset.bound = '1';
        const offset = Number(el.dataset.reveal) || 0;
        const update = () => el.classList.toggle('is-visible', window.scrollY >= offset);
        update();
        window.addEventListener('scroll', update, { passive: true });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
